/*
  Notify-me back-in-stock form interceptor.

  Document-delegated submit handler for [data-notify-me-form]. POSTs the
  {variant_id, email} payload to the Klaviyo back-in-stock endpoint.

  // TODO: open-question #3 — Klaviyo API not configured until Phase 11.
  // Once Klaviyo's a-list-id and API key are set in theme settings, swap
  // the console.log + mock-success block below for a real POST to
  // https://a.klaviyo.com/api/onsite/components/back-in-stock/subscribe
  // with the merchant's list ID. See SHOPIFY-HANDOFF.md section 11 for
  // the planned wiring.
*/

(() => {
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-notify-me-form]');
    if (!form) return;
    e.preventDefault();

    const variantId = form.dataset.variantId || form.querySelector('[name="variant_id"]')?.value;
    const email = form.querySelector('[name="email"]')?.value?.trim();
    if (!email || !variantId) return;

    const submitBtn = form.querySelector('button[type="submit"]');
    const successEl = form.parentElement?.querySelector('[data-notify-success]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'SENDING…';
    }

    try {
      // Phase 11 swap-point — see header comment.
      console.log('[notify-me] Phase 11 stub. Payload:', { variant_id: variantId, email });
      await new Promise((r) => setTimeout(r, 350)); // simulate request latency
    } catch (err) {
      console.error('[notify-me] submission failed:', err);
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'NOTIFY ME →';
      }
      return;
    }

    // Success state — hide form, show success message.
    form.hidden = true;
    if (successEl) successEl.hidden = false;
  });
})();
